import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Observable } from 'rxjs';
import { ICellRendererParams } from 'ag-grid-community';
import { LSCField } from '../../../../../models/LSCFields';
import { isLocationFieldBlacklisted } from '../../../location-utils';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';
import { Location } from '../../../../../models/locations-models/location';

export interface CoordinateCellState extends AgCellState {}

@Injectable()
export class CoordinateCellLocalStoreService extends AgCellLocalStoreService<CoordinateCellState> {

  viewModel$: Observable<{ isFieldBlacklisted: boolean,
    params: ICellRendererParams<Location>,
    loading: boolean }> =
      this.select(this.params$,
          this.gridLocalStore.loadingValues$,
          (params, loadingValues) => {
            return {
              isFieldBlacklisted: isLocationFieldBlacklisted((params?.colDef?.field) as LSCField, params?.data),
              params,
              loading: loadingValues[params?.data?.id]?.[params?.colDef?.field]
            };
          })

  constructor(private gridLocalStore: LocationListLocalStoreService) {
    super({
      cellValue: '',
      params: null
    })
  }
}
